module.exports = __webpack_public_path__ + "static/media/add_data_page_icon.a904e654.svg";